angular.module('app.controllers').controller 'ExhibitorsListCtrl', [
  '$scope', '$rootScope', 'APIExhibitors', 'UI', 'APIRead', 'APIReadTable', 'Table'
].append (self, root, APIExhibitors, UI, APIRead, APIReadTable, Table) ->

  tableName   = 's.l.' + (root.user?.shortcode || 'test')
  cookiesName = 't.' + tableName


  self.customStat(self.id, 'page_overview', "Automation Solutions Overview opened")

  self.exhibitors = Table
    name: tableName
    type: "partial"
    resource: APIReadTable
    params:
      limit: 12
      entry_type: 'campaign'
      lang: 'en'
  
  self.$watch 'exhibitors.params', (newObj, oldObj) ->
    self.page = 1
  , true

  self.page = 1
  self.loadMore = () ->
    return if self.page >= self.exhibitors.data.pages
    
    self.page++ 
    
    params = angular.copy(self.exhibitors.params)
    params.page = self.page

    self.moreLoad = true
    APIRead.query params, (data) ->
      self.more = data
      self.exhibitors.data.display = self.exhibitors.data.display.concat(self.more)
      self.moreLoad = false
